import React, { useState, useEffect, Suspense } from 'react';
import { cmp, oldCmp } from '@guardian/consent-management-platform';
import { getCountryCode } from '@root/src/web/lib/getCountryCode';
import { getPrivacyFramework } from '@root/src/web/lib/getPrivacyFramework';
import { addPrivacySettingsLink } from './CMPPrivacyLink';
export const willShowCMP = async () => {
    const framework = await getPrivacyFramework();
    if (!framework.ccpa && !framework.tcfv2) {
        addPrivacySettingsLink();
        return false;
    }
    const isInUsa = (await getCountryCode()) === 'US';
    cmp.init({
        isInUsa,
    });
    addPrivacySettingsLink();
    return cmp.willShowPrivacyMessage();
};
// this is the wrong place to be doing this, but it's temporary
// until we remove the old react CMP component and go 100% sourcepoint
export const shouldShowOldCMP = async () => (await getPrivacyFramework()).tcfv1 ? oldCmp.shouldShow() : false;
export const CMP = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        setShow(true);
        // setErrorHandler takes function to be called on errors in the CMP UI
        oldCmp.setErrorHandler((errMsg) => {
            const err = new Error(errMsg);
            window.guardian.modules.sentry.reportError(err, 'cmp');
        });
    }, []);
    return (React.createElement(React.Fragment, null, show && (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
        React.createElement(oldCmp.ConsentManagementPlatform, { source: "dcr", onClose: () => setShow(false) })))));
};
